import { render, staticRenderFns } from "./screen_component_crud.vue?vue&type=template&id=81370f76"
import script from "./screen_component_crud.vue?vue&type=script&lang=js"
export * from "./screen_component_crud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports